/**
 * Washington State Fire Protection Bureau Firefighter Skill Sheets Data
 * Auto-generated from PDF extraction - DO NOT EDIT MANUALLY
 * 
 * Contains all 59 NFPA 1001 firefighter certification skill sheets
 * extracted from the WSP FF1 training materials.
 */

import { SkillSheet, SkillSheetCollection, SkillSheetsBank } from '../types/wspSkillSheets';

export const WSP_FF1_SKILL_SHEETS: SkillSheet[] = [
  {
    skill_sheet_number: 1,
    page: 3,
    nfpa_standard: "1001, 2019  Edition",
    jpr: "4.1.2",
    skill_area: "General Skill Requirement s: Don and Doff PPE",
    task: "Don personal protective clothing within a reasonable amount of time: doff personal protective clothing and prepare for reuse.",
    conditions: null,
    performance_outcome: "The candidate shall be able to properly don personal protective clothing within a reasonable amount of time and to prepare the personal protective clothing for reuse.",
    task_steps: [
      {
        number: 1,
        task_step: "Don pants and boots – with all fasteners secured in place"
      },
      {
        number: 2,
        task_step: "Don hood covering ears, head, and neck"
      },
      {
        number: 3,
        task_step: "Don coat – including storm flap closed and collar up and secured"
      },
      {
        number: 4,
        task_step: "Don helmet and secure with chinstrap"
      },
      {
        number: 5,
        task_step: "Don gloves with no skin exposed"
      },
      {
        number: 6,
        task_step: "Complete above correctly within a reasonable amount of time or local AHJ Standard DOFFING"
      },
      {
        number: 7,
        task_step: "Place all equipment in a ready state for reuse"
      },
    ]
  },
  {
    skill_sheet_number: 2,
    page: 4,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.1.2",
    skill_area: "General Skill Requirement s: Knots , Bends, and Hitches",
    task: "Tie the following knots, bends, and hitches: bowline knot, clove hitch, figure eight on a bight, half -hitch, Becket/sheet bend, and overhand safety knots.",
    conditions: "Given appropriate and adequate rope(s) and in full personal protective clothing, the candidate shall demonstrate the ability to tie knots, bends, and hitches listed below.",
    performance_outcome: "The candidate, while operating on a simulated fire ground, shall be able to tie knots, bends, and hitches used in fire service.",
    task_steps: [
      {
        number: 1,
        task_step: "Bowline knot"
      },
      {
        number: 2,
        task_step: "Clove hitch"
      },
      {
        number: 3,
        task_step: "Figure eight on a bight"
      },
      {
        number: 4,
        task_step: "H alf hitch"
      },
      {
        number: 5,
        task_step: "B ecket bend"
      },
      {
        number: 6,
        task_step: "O verhand safety knot"
      },
    ]
  },
  {
    skill_sheet_number: 3,
    page: 5,
    nfpa_standard: "1001, 2019  Edition",
    jpr: "4.2.1,",
    skill_area: "Fire Department Communications : Use of telephone",
    task: "Receive a telephone call.",
    conditions: "Given a telephone and/or intercom equipment and other necessary equipment and a real or simulated call from the evaluator, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to properly answer a fire department business phone, ensuring that the proper procedures for answering a department telephone are used and the caller’s information is relayed.",
    task_steps: [
      {
        number: 1,
        task_step: "Answer the call promptly"
      },
      {
        number: 2,
        task_step: "Identify self and the department to the caller"
      },
      {
        number: 3,
        task_step: "Take a brief message (e.g., date, time, caller, caller’s call back number, message, and person taking call)"
      },
      {
        number: 4,
        task_step: "End the call courteously, in a timely manner; hang up after customer hangs up"
      },
      {
        number: 5,
        task_step: "Deliver message promptly to appropriate person or transfer call to appropriate party"
      },
    ]
  },
  {
    skill_sheet_number: 4,
    page: 6,
    nfpa_standard: "1001, 2019  Edition",
    jpr: "4.2.3",
    skill_area: "Fire Department Communications : Transm it and Receive Routine Messages",
    task: "Transmit and receive messages via the fire department radio.",
    conditions: "The evaluator will role -play the unit being called. Given a fire department mobile or portable radio and scripted message, the candidate shall be able to:",
    performance_outcome: "The candidate, while operating on a simulated fire ground, shall be able to transmit and receive messages via a fire department radio so that the information is promptly relayed and is accurate, complete, and clear.",
    task_steps: [
      {
        number: 1,
        task_step: "Determine the radio is on and tuned to assigned/appropriate frequency/channel"
      },
      {
        number: 2,
        task_step: "Use department’s operating procedures and/or codes"
      },
      {
        number: 3,
        task_step: "Routine Traffic – Determine air is clear before transmitting (emergency traffic shall not be interrupted)"
      },
      {
        number: 4,
        task_step: "Hold microphone appropriately before speaking"
      },
      {
        number: 5,
        task_step: "Speak calmly, clearly, distinctly, and at a medium speed"
      },
      {
        number: 6,
        task_step: "Transmit a message using clear text that is brief, accurate, and to the point"
      },
      {
        number: 7,
        task_step: "Identify the person or unit being called"
      },
      {
        number: 8,
        task_step: "Identify the person or unit transmitting"
      },
      {
        number: 9,
        task_step: "Acknowledge and respond appropriately to received messages"
      },
    ]
  },
  {
    skill_sheet_number: 5,
    page: 7,
    nfpa_standard: "1001, 2019  Edition",
    jpr: "4.2.4",
    skill_area: "Fire Department Communications : Transmit and Receive Emergency Messages",
    task: "Activate an emergency call for assistance, given vision obscured conditions PPE and department sops so firefighter(s) can be located and rescued.",
    conditions: "The evaluator will role -play the unit being called. Given a fire department mobile or portable radio and scripted message, the candidate shall be able to:",
    performance_outcome: "The candidate, while operating on a simulated fire ground, shall be able to transmit and receive messages via a fire department radio so that the information is promptly relayed and is accurate, complete, and clear.",
    task_steps: [
      {
        number: 1,
        task_step: "Determine the radio is on and tuned to assigned/appropriate frequency/channel"
      },
      {
        number: 2,
        task_step: "Use department’s operating procedures and/or codes"
      },
      {
        number: 3,
        task_step: "Emergency Traffic – Announce emergency traffic , even if interrupting other traffic, if necessary"
      },
      {
        number: 4,
        task_step: "Hold microphone appropriately before speaking"
      },
      {
        number: 5,
        task_step: "Speak calmly, clearly, distinctly, and at a medium speed"
      },
      {
        number: 6,
        task_step: "Transmit a message using clear text that is brief, accurate, and to the point"
      },
      {
        number: 7,
        task_step: "Identify the person or unit transmitting"
      },
      {
        number: 8,
        task_step: "Contact Appropriate Agency or person (i.e. Command, Dispatch etc.) the necessary information per local SOPs. (For example LUNARS – Location, Unit, Name or ID #, Assignment, Resources Needed, and Situation)"
      },
      {
        number: 9,
        task_step: "Acknowledge and respond appropriately to received messages"
      },
    ]
  },
  {
    skill_sheet_number: 6,
    page: 8,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.1",
    skill_area: "Fire Ground Operations: Use SCBA during emergenc y operations, Don and Doff SCBA",
    task: "Use SCBA during emergency operations.",
    conditions: "Given a SCBA and in full protective clothing, the candidate shall be able to correctly don all protective clothing and SCBA on air.",
    performance_outcome: "The candidate, while operating at a simulated fire scene or cab of apparatus, and in full protective clothing, shall be able to correctly don and activate the SCBA in a reasonable amount of time .",
    task_steps: [
      {
        number: 1,
        task_step: "Correctly don SCBA including: • Check amount of air in cylinder; and • Check operation of low air alarm • Verify PASS device has activated"
      },
      {
        number: 2,
        task_step: "Correctly don face piece including: • Check seal; and • Operation of exhalation valve"
      },
      {
        number: 3,
        task_step: "Have all personal protective clothing correctly in place"
      },
      {
        number: 4,
        task_step: "Accomplished all of the above correctly in a reasonable amount of time or local AHJ Standard"
      },
      {
        number: 5,
        task_step: "Correctly don SCBA including: • Check amount of air in cylinder; and • Check operation of low air alarm • Verify PASS device has activated"
      },
      {
        number: 6,
        task_step: "Correctly don face piece including: • Check seal; and • Operation of exhalation valve"
      },
      {
        number: 7,
        task_step: "Have all personal protective clothing correctly in place"
      },
      {
        number: 8,
        task_step: "Accomplished all of the above correctly in a reasonable amount of time or local AHJ Standard"
      },
    ]
  },
  {
    skill_sheet_number: 7,
    page: 9,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.1",
    skill_area: "Fire Ground Operations: Use SCBA during Emergency Operations",
    task: "Use of SCBA during emergency operation: perform conservation of air and emergency procedures.",
    conditions: "Given personal protective clothing and SCBA, the candidate shall be able to perform the following: (Note: The evaluator will select at least one procedure from conservation of air, one procedure from SCBA failure, one procedure from depletion of air supply, and alarm mode -emergency notification from pass device use).",
    performance_outcome: "The candidate, while operating in a simulated IDLH environment, shall be able to use controlled breathing techniques and perform eme rgency procedures in the event of SCBA failure.",
    task_steps: [
      {
        number: 1,
        task_step: "Demonstrate controlled breathing inhale through the nose exhale through the mouth control rate of breathing II. SCBA FAILURE"
      },
      {
        number: 1,
        task_step: "Emergency procedures when air is not flowing into the face piece : Check that cylinder is fully open Open bypass slowly Close bypass after each breath Open bypass for next breath Exit hazardous area rapidly"
      },
      {
        number: 2,
        task_step: "Emergency procedures when face piece is no longer intact: Breathe directly from regulator Make tight seal around regulator with mouth or blow by procedure and exhale through nose Exit hazardous area rapidly III. DEPLETION OF AIR SUPPLY"
      },
      {
        number: 1,
        task_step: "Emergency procedures when out of air with no air re -supply available Activate pass device Establish filter breathing, per AHJ Standard Operating Procedures Exit hazardous area rapidly"
      },
      {
        number: 2,
        task_step: "Emergency procedures when out of air with a full cylinder available Doff backpack Close cylinder valve and release pressure Disconnect hose from cylinder Remove depleted cylinder Replace with cylinder containing air Connect hose to cylinder Turn on cylinder Redon back pack"
      },
      {
        number: 1,
        task_step: "Manually activate PASS device in alarm mode"
      },
    ]
  },
  {
    skill_sheet_number: 8,
    page: 11,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.1",
    skill_area: "Fire Ground Operations: Use SCBA during Emergency Operations",
    task: "Use SCBA during emergency operation: exit IDLH environment before air supply depletion .",
    conditions: "Given SCBA, hand light, assortment of forcible entry tools, team member, scenario with hazardous environment, and in full protective equipment, the candidate shall be able to:",
    performance_outcome: "The candidate, while operating as a member of a team at a simulated fire scene, shall be able to operate in a simulated IDLH environment, keeping track of his/her air supply so that the hazardous area is exited prior to depletion of the air supply.",
    task_steps: [
      {
        number: 1,
        task_step: "Determine air supply available when entering hazardous atmosphere"
      },
      {
        number: 2,
        task_step: "Monitor the air supply available while in hazardous atmosphere"
      },
      {
        number: 3,
        task_step: "Make decision to leave hazardous atmosphere with team member(s) before depletion of air supply"
      },
      {
        number: 4,
        task_step: "Notify supervisor by radio that air supply is low and state team will be exiting the hazardous environment"
      },
      {
        number: 5,
        task_step: "Exit hazardous atmosphere before depletion of air supply"
      },
    ]
  },
  {
    skill_sheet_number: 9,
    page: 12,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.2",
    skill_area: "Fire Ground Operations: Respond on an Apparatus to an Emergency Scene",
    task: "Respond on an apparatus to an emergency scene.",
    conditions: "Given personal protective clothing and other necessary personal protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to prepare to respond correctly in a fire department apparatus and to correct ly dismount at the emergency scene.",
    task_steps: [
      {
        number: 1,
        task_step: "Mount fire apparatus using handrails and steps"
      },
      {
        number: 2,
        task_step: "Close door, safety bar, gate to cab or compartment"
      },
      {
        number: 3,
        task_step: "Sit, fasten seat belt, and notify driver"
      },
      {
        number: 4,
        task_step: "Correctly use hearing protection when present DISMOUNTING"
      },
      {
        number: 1,
        task_step: "Wait for orders before leaving apparatus"
      },
      {
        number: 2,
        task_step: "Ensure that vehicle is completely stopped before disconnecting restraints and preparing to leave apparatus, leave downstream or curb side if possible"
      },
      {
        number: 3,
        task_step: "Look for any hazards before opening the door and stepping off vehicle"
      },
      {
        number: 4,
        task_step: "Safely step from vehicle using handrails and steps"
      },
      {
        number: 5,
        task_step: "Close door and ensure you are in an area protected from hazards"
      },
    ]
  },
  {
    skill_sheet_number: 10,
    page: 13,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.3",
    skill_area: "Fire Ground Operations: Operate in established work areas at Emergency Scene",
    task: "Operate in an established work area at an emergency scene with high flow traffic .",
    conditions: "Given personal protective clothing, other necessary personal protective equipment, and traffic and scene control devices, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to operate in a high traffic environment so that procedures are followed, personal protective clothing is worn, a protective work area is establi shed, and traffic is controlled.",
    task_steps: [
      {
        number: 1,
        task_step: "Wear all personal protective clothing necessary for working in a traffic area. and wear a Class III vest"
      },
      {
        number: 3,
        task_step: "Establish a working zone downstream from the blocking apparatus using cones and/or flares ( NOTE: must first check area for flammable material before using flares)"
      },
      {
        number: 4,
        task_step: "Always face approaching traffic when working upstream of the blocking apparatus"
      },
      {
        number: 5,
        task_step: "Demonstrate the ability to direct the movement of traffic at the scene of the incident"
      },
      {
        number: 6,
        task_step: "Always face approaching traffic when picking up the traffic control devices"
      },
      {
        number: 7,
        task_step: "Wear all personal protective clothing necessary for working in a traffic area. and wear a Class III vest"
      },
    ]
  },
  {
    skill_sheet_number: 11,
    page: 14,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.3",
    skill_area: "Fire Ground Operations: Operate in established work areas at Emergency Scene",
    task: "Operate in established work area at a traffic area emergency scene with downed electrical wire hazards .",
    conditions: "Given personal protective clothing, other necessary personal protective equipment, and traffic and scene control devices, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to operate in a downed electrical wire environment so that procedures are followed, personal protective clothing is worn, and a protective work area is established.",
    task_steps: [
      {
        number: 1,
        task_step: "Establish a hot zone around a downed electrical wire hazard according to the following instructions. Using a radius of one span of the lines, mark a circle around each of the power poles on each side of the broken or downed line or per AHJ Standard Operating Procedures"
      },
      {
        number: 2,
        task_step: "Enlarge the hot zone around a downed electrical wire hazard if the wire is in contact with a conductive material such as a fence, gate, building, etc."
      },
      {
        number: 3,
        task_step: "Using scene and/or traffic control devices, mark the hot zone"
      },
      {
        number: 4,
        task_step: "Construct a traffic control zone around the area using the following:"
      },
    ]
  },
  {
    skill_sheet_number: 12,
    page: 15,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.4",
    skill_area: "Fire Ground Operations: Force Entry into a Structure , Door",
    task: "Force entry into a structure: through a door.",
    conditions: "Given a selection of forcible entry tools, an entry door, and in full protective clothing, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to properly force entry into a structure through a locked door using one or more of the provided forcible entry tools.",
    task_steps: [
      {
        number: 1,
        task_step: "Select the appropriate tool(s)"
      },
      {
        number: 2,
        task_step: "Safely carry the selected tool(s) to the door"
      },
      {
        number: 3,
        task_step: "Try the door to make sure locked before forcing"
      },
      {
        number: 4,
        task_step: "Use hand and eye protection"
      },
      {
        number: 5,
        task_step: "Demonstrate the appropriate technique based on door construction"
      },
      {
        number: 6,
        task_step: "Control the door and clear opening of obstacles"
      },
    ]
  },
  {
    skill_sheet_number: 13,
    page: 16,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.4",
    skill_area: "Fire Ground Operations: Force Entry into a Structure , Window",
    task: "Force entry into a structure: through a window .",
    conditions: "Given a selection of forcible entry tools, a window, and in full protective clothing, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to properly force entry into a structure through a locked window using one or more of the provided forcible entry tools.",
    task_steps: [
      {
        number: 1,
        task_step: "Select the appropriate tool(s)"
      },
      {
        number: 2,
        task_step: "Safely carry the selected tool(s) to the window"
      },
      {
        number: 3,
        task_step: "Try the window to make sure locked before forcing"
      },
      {
        number: 4,
        task_step: "Correctly size up the window"
      },
      {
        number: 5,
        task_step: "Use hand and eye protection"
      },
      {
        number: 6,
        task_step: "Demonstrate the appropriate technique based on window construction"
      },
      {
        number: 7,
        task_step: "If breaking glass, keep hands and the tool handle above the point of impact (if applicable)"
      },
      {
        number: 8,
        task_step: "Remove remaining glass and obstacles"
      },
    ]
  },
  {
    skill_sheet_number: 14,
    page: 17,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.4",
    skill_area: "Fire Ground Operations: Force Entry into a Structure , Wall",
    task: "Force entry into a structure: through a wall.",
    conditions: "Given a selection of forcible entry tools, a window, and in full protective clothing, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to properly force entry into a structure through a wall using one or more of the provided forcible entry tools.",
    task_steps: [
      {
        number: 1,
        task_step: "Correctly size up the wall to be breached"
      },
      {
        number: 2,
        task_step: "Identify breaching hazards"
      },
      {
        number: 3,
        task_step: "Select the correct tool(s) for the type of wall"
      },
      {
        number: 4,
        task_step: "Demonstrate the appropriate technique based on wall construction"
      },
      {
        number: 5,
        task_step: "Sound for studs and cut alongside, if appropriate"
      },
      {
        number: 6,
        task_step: "Make an appropriate- sized opening"
      },
      {
        number: 7,
        task_step: "Watch for utilities in wall while opening"
      },
    ]
  },
  {
    skill_sheet_number: 15,
    page: 18,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.5",
    skill_area: "Fire Ground Operations: Exit a Hazardous Area as a Team",
    task: "Exit an IDLH environment vision -obscured area to a safe haven , maintaining team integrity, before the air supply is exhausted.",
    conditions: "Given an area of obscured visibility, a team member, hand light, assortment of forcible entry tools, portable radio, charged hose line or guideline, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to identify the need to exit a hazardous area, develop a plan of egress, communicate the plan to supervisor and subordinate, and exit the hazardous area.",
    task_steps: [
      {
        number: 1,
        task_step: "Identify the need to exit the hazardous environment"
      },
      {
        number: 2,
        task_step: "Communicate and coordinate egress with team member"
      },
      {
        number: 3,
        task_step: "Communicate egress plan with immediate supervisor by radio"
      },
      {
        number: 4,
        task_step: "Follow guideline or hose line to point of egress"
      },
      {
        number: 5,
        task_step: "Maintain team integrity"
      },
      {
        number: 6,
        task_step: "Exit area to a safe haven before air supply is exhausted or low air sounds"
      },
    ]
  },
  {
    skill_sheet_number: 16,
    page: 19,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.6",
    skill_area: "Fire Ground Operations: Set up Ground Ladders",
    task: "Set up ground ladder.",
    conditions: "Given the appropriate ground extension ladder(s) (24’ -35’), the candidate, while acting as team leader and while in complete personal protective clothing and SCBA (as required by the scenario), shall demonstrate the ability to:",
    performance_outcome: "The candidate, while working as part of a team, and while operating on a simulated fire ground, shall lift, carry, and raise the assigned extension ladder for an assigned task.",
    task_steps: [
      {
        number: 1,
        task_step: "Select the proper length ladder for the designated task"
      },
      {
        number: 2,
        task_step: "Inform team member(s) which of the following methods of carry should be utilized: Circle skill tested : a. Low shoulder b. High shoulder c. Arm’s length c. Flat carry"
      },
      {
        number: 3,
        task_step: "Determine that a wall and/or roof will support the ladder"
      },
      {
        number: 4,
        task_step: "Visually check the work area for hazards, including overhead wires and obstructions, and state if the area is clear to raise the ladder"
      },
      {
        number: 5,
        task_step: "Determine the appropriate raise (beam or flat) to be utilized"
      },
      {
        number: 6,
        task_step: "Properly raise the ladder upright in a safe manner"
      },
      {
        number: 7,
        task_step: "Ensure correct fly placement, rotating the ladder, if necessary"
      },
      {
        number: 8,
        task_step: "Properly extend, secure (lock) fly section"
      },
      {
        number: 9,
        task_step: "Lower ladder against stable wall or surface"
      },
      {
        number: 10,
        task_step: "Secure the halyard with agency specific method"
      },
      {
        number: 12,
        task_step: "Adjust for correct climbing angle LOWERING THE LADDER (IF REQUIRED BY SCENA RIO)"
      },
      {
        number: 1,
        task_step: "Release halyard, pull ladder away from the building, lower the fly(s)"
      },
      {
        number: 2,
        task_step: "Ground the ladder using either a flat or beam lower"
      },
    ]
  },
  {
    skill_sheet_number: 17,
    page: 21,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.7",
    skill_area: "Fire Ground Operations: Attack an passenger vehicle fire",
    task: "Attack a passenger vehicle fire operating as a member of a team.",
    conditions: "Given a working vehicle fire, a charged attack line(s) 1 ½” or larger, wind direction, hand tools, a team, a dedicated safety line with personnel, and in full personal protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at a vehicle fire, shall properly attack and extinguish the fire.",
    task_steps: [
      {
        number: 1,
        task_step: "Properly wear full protective equipment, including SCBA on air, ensure all team member are in full protective equipment including SCBA, on air while in IDLH atmosphere"
      },
      {
        number: 2,
        task_step: "Attack from upwind and uphill (if on hill)"
      },
      {
        number: 3,
        task_step: "Protect exposures, if present"
      },
      {
        number: 4,
        task_step: "Identify possible fuel types and methods for controlling fuel leaks"
      },
      {
        number: 5,
        task_step: "Bleed line, and adjust nozzle to straight stream to extinguish ground fires around and under the vehicle"
      },
      {
        number: 7,
        task_step: "Attack the remaining fire in the vehicle starting with the passenger compartment first (if fire present), gaining any access needed, using a narrow or straight stream pattern with a circular motion"
      },
      {
        number: 8,
        task_step: "Extinguish any remaining fire in the vehicle (gaining any access needed) with a narrow or straight stream pattern with a circular motion"
      },
      {
        number: 9,
        task_step: "Overhaul the fire scene (simulate overhaul if applicable)"
      },
    ]
  },
  {
    skill_sheet_number: 18,
    page: 22,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.8",
    skill_area: "Fire Ground Operations: Extinguish Class A exterior fire",
    task: "Extinguish fires in exterior Class A materials: given fires in stacked or piled small unattached structures or storage containers , or trash containers of Class A materials in an exterior setting.",
    conditions: "Given a live exterior fire involving stacks of Class A materials, attack line(s) 1 ½” or greater, wind direction, hand tools, a team member, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at an exterior fire involving stacks of Class A materials, shall properly attack and extinguish the fire.",
    task_steps: [
      {
        number: 1,
        task_step: "Describe inherent hazards related to the burning material’s configuration"
      },
      {
        number: 2,
        task_step: "Properly wear full protective equipment, including SCBA on air, ensure all team member are in full protective equipment including SCBA, on air while in IDLH atmosphere"
      },
      {
        number: 3,
        task_step: "Properly bleed attack line and adjust nozzle to straight stream"
      },
      {
        number: 4,
        task_step: "Attack from uphill, upwind and/or flanks, if possible"
      },
      {
        number: 5,
        task_step: "Protect exposures (if present)"
      },
      {
        number: 6,
        task_step: "Approach the fire using a fog pattern for protection from heat, if needed"
      },
      {
        number: 7,
        task_step: "Complete the extinguishment of the fire with a straight stream at the base of the fire"
      },
      {
        number: 8,
        task_step: "Search for, expose, and extinguish any remaining hidden fire"
      },
      {
        number: 9,
        task_step: "Overhaul fire scene while protecting and preserving signs of cause and origin, if present"
      },
      {
        number: 10,
        task_step: "Select skill tested: ☐ fires stacked or piled materials; ☐ small unattached structures or storage containers; ☐ trash containers"
      },
    ]
  },
  {
    skill_sheet_number: 19,
    page: 24,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.8",
    skill_area: "Fire Ground Operations: Extinguish Fire s in exterior Class A materials",
    task: "Deploy and operate a Master Stream Device .",
    conditions: "Given a simulated exterior Class A fire, a Master Stream Device, supply hose, and a water supply (pumper), a team member, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at a Class A exterior fire, shall properly deploy and operate a Master Stream Device.",
    task_steps: [
      {
        number: 1,
        task_step: "Assemble necessary tools, hose, and appliances for setup"
      },
      {
        number: 2,
        task_step: "With assistance, place master stream device into position"
      },
      {
        number: 3,
        task_step: "Position the master stream device on a solid, level surface"
      },
      {
        number: 4,
        task_step: "Secure the device, as necessary"
      },
      {
        number: 5,
        task_step: "Deploy hose line(s) and connect to the device"
      },
      {
        number: 6,
        task_step: "Ensure the connections are tight"
      },
      {
        number: 7,
        task_step: "Set the nozzle to desired elevation and direct engineer to charge line(s) not to exceed manufacture’s limits"
      },
      {
        number: 8,
        task_step: "Secure the anchor lock, if applicable"
      },
      {
        number: 9,
        task_step: "Steady the device and signals to shut down if unstable"
      },
      {
        number: 10,
        task_step: "Demonstrate directing the stream"
      },
    ]
  },
  {
    skill_sheet_number: 20,
    page: 25,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.9",
    skill_area: "Fire Ground Operations: Conduct a search and rescue in a structure",
    task: "Conduct and complete a primary search of a simulated IDLH environment, locating and removing all victim(s), while operating as a member of a two -person team and using an attack line.",
    conditions: "Given a search and rescue scenario, an area of obscured visibility, a team member, an assortment of forcible entry tools(s), a hose line or guideline, hand light, portable radio, and in full protective equipment with SCBA , the candidate shall demonstrate t he ability to:",
    performance_outcome: "The candidate shall demonstrate the necessary skills to conduct a primary search, covering as wide of an area as quickly as possible, removing the victim(s) to designated safe havens, and maintaining team integrity and communication.",
    task_steps: [
      {
        number: 1,
        task_step: "Properly wear full protective clothing and SCBA on air and ensure team member is also in full protective clothing and SCBA on air"
      },
      {
        number: 2,
        task_step: "Size up the problem, assess area for tenability and select the appropriate tool(s) and equipment"
      },
      {
        number: 3,
        task_step: "Ladders are correctly placed for assignment (if required by scenario)"
      },
      {
        number: 4,
        task_step: "Correctly open all doors (feeling for heat and opening slowly, keeping control of the door ) or windows"
      },
      {
        number: 5,
        task_step: "Establish and maintain an effective search pattern"
      },
      {
        number: 6,
        task_step: "Search in a body position appropriate for conditions (e.g., crawling, walking)"
      },
      {
        number: 7,
        task_step: "Maintain team communication, safety, and integrity"
      },
      {
        number: 8,
        task_step: "Use hose line or guideline effectively"
      },
      {
        number: 9,
        task_step: "Find and correctly remove all victims CIRCLE Victim(s) Rescued: a. Person without Respiratory Protection b. Firefighter with FUNCTIONING SCBA c. Firefighter with Non -FUNCTIONING SCBA"
      },
      {
        number: 10,
        task_step: "Complete the search"
      },
      {
        number: 11,
        task_step: "Properly wear full protective clothing and SCBA on air and ensure team member is also in full protective clothing and SCBA on air"
      },
    ]
  },
  {
    skill_sheet_number: 21,
    page: 27,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.9",
    skill_area: "Skill Area: Fire Ground Operations: Conduct a search and rescue in a structure",
    task: "Exit and navigate a restricted passage while wearing SCBA.",
    conditions: "Given a restricted passage in full protective equipment and in SCBA on air, the candidate shall demonstrate the ability to: (Note: The evaluator will choose which method to use performing the skill.)",
    performance_outcome: "The candidate shall demonstrate the necessary skills to exit through a restricted passage, while wearing full protective clothing and SCBA, on air.",
    task_steps: [
      {
        number: 1,
        task_step: "While exiting a hazardous area, encountering a restricted passage, the candidate is able to enter the restricted space and proceed through the space using one of the methods listed below. Ensure area going into is safe by sounding the floor on the other s ide. Circle skill method tested . I. REDUCING PROFILE METHOD Loosen straps as necessary to reduce profile by sliding tank to side"
      },
      {
        number: 1,
        task_step: "Reduce profile further by removing one or both backpack harness straps (if absolutely necessary)"
      },
      {
        number: 2,
        task_step: "Enter opening, head first, proceeding through opening and clearing opening completely"
      },
      {
        number: 3,
        task_step: "Redon SCBA backpack assembly"
      },
      {
        number: 4,
        task_step: "Ensure that mask seal or SCBA functioning was not compromised during maneuver"
      },
      {
        number: 5,
        task_step: "Continue exiting the hazardous area, maintaining respiratory protection II. EXIT – SCBA FIRST, BACKWARD METHOD"
      },
      {
        number: 1,
        task_step: "Sit with SCBA and back toward the opening"
      },
      {
        number: 2,
        task_step: "Place one arm and cylinder into the opening"
      },
      {
        number: 3,
        task_step: "Using a backstroke technique swim other arm through the opening"
      },
      {
        number: 4,
        task_step: "Use both arms and wall board for leverage and pull through the space"
      },
      {
        number: 5,
        task_step: "Ensure that mask seal and SCBA functioning was not compromised during maneuver III. REMOVING BACKPACK METHOD"
      },
      {
        number: 1,
        task_step: "Remove SCBA backpack, not compromising face -piece seal or ability to breathe"
      },
      {
        number: 2,
        task_step: "Push backpack through opening, not compromising SCBA operation"
      },
      {
        number: 3,
        task_step: "Enter opening, head first, proceeding through opening and clearing opening completely"
      },
      {
        number: 4,
        task_step: "Redon SCBA backpack assembly"
      },
      {
        number: 1,
        task_step: "Recognize the emergency"
      },
      {
        number: 2,
        task_step: "Stop moving and assess the situation"
      },
      {
        number: 3,
        task_step: "Stay calm , control breathing, activate pass device if separated from your team"
      },
      {
        number: 4,
        task_step: "Decide best steps to mitigate your situation and conserve energy"
      },
      {
        number: 5,
        task_step: "If possible back out of entanglement, or move forward with SCBA pack down and regulator protected with gloved hand"
      },
      {
        number: 6,
        task_step: "If unable to move forward or backward attempt swim technique to locate points of entanglement"
      },
      {
        number: 7,
        task_step: "If possible use cutting tool to cut out of entanglement"
      },
      {
        number: 8,
        task_step: "Ensure that mask seal or SCBA functioning was not compromised during maneuver"
      },
      {
        number: 9,
        task_step: "Continue exiting the hazardous area, maintaining respiratory protection"
      },
      {
        number: 10,
        task_step: "Assess the area to determine tenability"
      },
    ]
  },
  {
    skill_sheet_number: 22,
    page: 29,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.9",
    skill_area: "Fire Ground Operations: Conduct a search and rescue in a structure, Rescue from Window",
    task: "Rescue a victim by removing from a second story window.",
    conditions: "Given a search and rescue scenario where a victim is located near a window, a ladder, a team member on the ground level, a rescue mannequin (or firefighter) not weighing more than 250 pounds, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall demonstrate the necessary skills to raise a ladder for a window rescue, place a victim on the ladder, and bring the victim safely down the ladder to safety.",
    task_steps: [
      {
        number: 1,
        task_step: "Correctly place a ladder for window rescue"
      },
      {
        number: 2,
        task_step: "Ensure the ladder is heeled or secured, and at the proper climbing angle"
      },
      {
        number: 3,
        task_step: "Ascend the ladder, sound the floor for structural integrity before entering the window"
      },
      {
        number: 4,
        task_step: "Direct the two firefighters at the window to place the victim on the ladder using one of the methods listed below; the evaluator will pick either a conscious or unconscious victim"
      },
      {
        number: 5,
        task_step: "Select either conscious or unconscious victim rescue: Circle skill tested; a. Conscious Victim Victim is lowered feet first from the building to the ladder b. Unconscious Victim Same as conscious victim, except victim’s body rests on the rescuer’s supporting knee with the victim’s feet outside the rails to prevent entanglement; Rescuer grasps rungs to provide a secure hold on the ladder and to help protect victim’s head from hitting the ladder and supporting the arms Alternate lowering position ; is to use the same hold but have the unconscious victim’s face the rescuer; The unconscious victim is supported at the crotch by one of the rescuers arms and at the chest by the other arm; The rescuer may be aided by anot her firefighter"
      },
      {
        number: 6,
        task_step: "Rescuer safely descends the ladder with victim"
      },
    ]
  },
  {
    skill_sheet_number: 23,
    page: 31,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.10",
    skill_area: "Fire Ground Operations: Attack an Interior Structure Fire Note: Ground - level structure fire",
    task: "Attack an interior structure fire operating as a member of a team.",
    conditions: "Given a live interior structure fire, a charged attack line, hand tools, a team member, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as the nozzle person of a team at an interior structure fire involving Class A materials, shall properly attack and extinguish the fire.",
    task_steps: [
      {
        number: 1,
        task_step: "Properly wear full protective clothing and SCBA on air and ensure team member is also in full protective clothing and SCBA (on air)"
      },
      {
        number: 2,
        task_step: "Instruct the team member to carry the selected hand tool"
      },
      {
        number: 3,
        task_step: "Bleed attack line and adjust nozzle pattern (select highest flow if using adjustable gallonage nozzle)"
      },
      {
        number: 4,
        task_step: "Instruct team member to check door"
      },
      {
        number: 5,
        task_step: "Cover door to protect team member"
      },
      {
        number: 6,
        task_step: "Stay low on entering and approaching fire"
      },
      {
        number: 7,
        task_step: "Extinguish the fire using the attack pattern directed to use by evaluator Circle attack pattern(s) directed to use: DIRECT INDIRECT COMBINATION"
      },
      {
        number: 8,
        task_step: "Locate and suppress interior wall and subfloor fires"
      },
    ]
  },
  {
    skill_sheet_number: 24,
    page: 32,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.10",
    skill_area: "Fire Ground Operations: Attack an Interior Structure Fire Note: Str ucture fire above ground level",
    task: "Attack an interior structure fire operating as a member of a team.",
    conditions: "Given a scenario for a n above -ground level interior structure fire, attack line, hand tools, a team, and in full protective equipment, the candidate shall demonstrate the ability to:(Note: If a standpipe is present, 100’ of 1 ½: or 1 ¾” attack line with nozzle, a gated wye, a sp anner wrench will be furnished.)",
    performance_outcome: "The candidate, while operating as a member of a team at an above -ground interior structure fire involving Class A materials, shall properly attack and extinguish the fire.",
    task_steps: [
      {
        number: 1,
        task_step: "Properly wear full protective clothing and SCBA on air and ensure team member is also in full protective clothing and SCBA (on air)"
      },
      {
        number: 2,
        task_step: "Place ladder or ensure ladder placed to fire floor, if reachable, for access, secondary egress or fire attack (based on scenario given)"
      },
      {
        number: 3,
        task_step: "Check door before entering first floor I. STANDPIPE PRESENT"
      },
      {
        number: 1,
        task_step: "Obtain hose bundle, nozzle, gated wye, and spanner wrench and proceed with team member to floor below fire floor"
      },
      {
        number: 2,
        task_step: "Direct team member to connect gated wye to standpipe and connect attack line to wye outlet ( couple and uncouple hose as required to assigned task)"
      },
      {
        number: 3,
        task_step: "Advance hose to fire floor so that nozzle is positioned at the fire floor with remaining dry line flaked up stairwell"
      },
      {
        number: 4,
        task_step: "Direct team member to charge attack line and ensure kinks are removed"
      },
      {
        number: 5,
        task_step: "Bleed attack line and adjust nozzle pattern (select highest flow if adjustable gallonage nozzle) while preventing water hammer"
      },
      {
        number: 6,
        task_step: "Describe hose line replacement method should hose line burst prior to entry"
      },
      {
        number: 7,
        task_step: "Cover door (protects team member) while team member checks door, sound floor for stability"
      },
      {
        number: 8,
        task_step: "Stay low on entering and approaching fire"
      },
      {
        number: 9,
        task_step: "Extinguish the fire using the attack pattern as directed by evaluator Circle attack pattern(s) directed to use: DIRECT INDIRECT COMBINATION II. NO STANDPIPE PRESENT"
      },
      {
        number: 1,
        task_step: "Bleed attack line and adjust nozzle pattern (select highest flow if adjustable gallonage nozzle) while preventing water hammer"
      },
      {
        number: 2,
        task_step: "Describe hose line replacement method should hose line burst prior to entry"
      },
      {
        number: 4,
        task_step: "Stay low on entering (if conditions warrant) and approaching fire"
      },
      {
        number: 5,
        task_step: "Advance hoseline through door to stairs, advance to stairs, and up the stairs to fire floor"
      },
      {
        number: 6,
        task_step: "Advance hoseline towards fire, staying low"
      },
      {
        number: 7,
        task_step: "Extinguish the fire using the attack pattern directed to use by evaluator Circle attack pattern(s) directed to use DIRECT INDIRECT COMBINATION"
      },
    ]
  },
  {
    skill_sheet_number: 25,
    page: 34,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.10",
    skill_area: null,
    task: "Attack an interior structure fire operating as a member of a team.",
    conditions: "Given a live interior below -grade level structure fire, a charged 1 ½” or 1 ¾” attack line, two team members, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at an interior below -grade level structure fire involving Class A materials, shall properly descend a stairwell to attack and extinguish a fire.",
    task_steps: [
      {
        number: 1,
        task_step: "Properly wear full protective clothing and SCBA on air and ensure that team members are in full protective clothing and SCBA on air"
      },
      {
        number: 2,
        task_step: "Ensure that there is extra hose line near entrance to stairwell"
      },
      {
        number: 3,
        task_step: "Bleed attack line and adjust nozzle pattern (select highest flow if adjustable gallon age nozzle)"
      },
      {
        number: 4,
        task_step: "Ventilate or call for ventilation above fire, if possible"
      },
      {
        number: 5,
        task_step: "Cover door to stairwell (protects team member) while team member checks door"
      },
      {
        number: 6,
        task_step: "Stay low on entering and approaching stairwell"
      },
      {
        number: 7,
        task_step: "Descend stairs, feet first, checking each riser for integrity"
      },
      {
        number: 8,
        task_step: "Descend stairs quickly using wide angle fog pattern"
      },
      {
        number: 9,
        task_step: "At bottom of stairs, search for and correctly extinguish the fire using the pattern as directed by evaluator"
      },
      {
        number: 10,
        task_step: "Circle attack pattern(s) directed to use: DIRECT INDIRECT COMBINATION"
      },
    ]
  },
  {
    skill_sheet_number: 26,
    page: 35,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.10",
    skill_area: "Fire Ground Operations: Replace burst section of hose",
    task: "Demonstrate the procedures for replacing a burst section of hose.",
    conditions: "Given a live interior below -grade level structure fire, a charged 1 ½” or 1 ¾” attack line, two team members, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall replace a burst or damaged hose section.",
    task_steps: [
      {
        number: 1,
        task_step: "Use hose clamp to stop flow or have driver operator shut down the line"
      },
      {
        number: 2,
        task_step: "Remove the damaged section of hose"
      },
      {
        number: 3,
        task_step: "Replace the damaged section of hose with two sections of hose and direct team member to straighten out the line"
      },
      {
        number: 4,
        task_step: "Ensure the nozzle is closed"
      },
      {
        number: 5,
        task_step: "Slowly and correctly release the clamp to prevent water surge or have driver operator charge the line"
      },
    ]
  },
  {
    skill_sheet_number: 27,
    page: 36,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.10",
    skill_area: "Fire Ground Operations: Demonstrate the p rocedures to extend a hose line",
    task: "Demonstrate the procedures to extend a hose line.",
    conditions: "Given a live interior below -grade level structure fire, a charged 1 ½” or 1 ¾” attack line, two team members, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall extend a hose line.",
    task_steps: [
      {
        number: 2,
        task_step: "Direct team member to bleed or bleed slowly the line by opening the nozzle"
      },
      {
        number: 3,
        task_step: "Remove the nozzle"
      },
      {
        number: 4,
        task_step: "Attach the additional hose line to the end of the last hose section"
      },
      {
        number: 5,
        task_step: "Attach or direct team member to attach the nozzle and stretch out the new line"
      },
      {
        number: 6,
        task_step: "Ensure the nozzle is closed"
      },
      {
        number: 7,
        task_step: "Slowly and correctly release the clamp to prevent water surge/ or have driver operator charge the line"
      },
    ]
  },
  {
    skill_sheet_number: 28,
    page: 37,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.10",
    skill_area: "Fire Ground Operations: Advancing an uncharged hose line up interior stairway",
    task: "Demonstrate advancing an uncharged hose line up interior stairway .",
    conditions: "The candidate, given an uncharged attack line, a team member, and in full protective equipment, shall demonstrate the ability to :",
    performance_outcome: "The candidate shall advance an uncharged hose line up an interior stairway.",
    task_steps: [
      {
        number: 1,
        task_step: "Shoulder adequate amount of hose line and advance to the fire floor (assistance is provided to feed hose up the stairway behind the candidate)"
      },
      {
        number: 2,
        task_step: "Flake off hose up the stairway leading to the floor above the fire floor"
      },
      {
        number: 3,
        task_step: "Arrange hose to the outside walls of stairwell to provide for a clear traveling path"
      },
    ]
  },
  {
    skill_sheet_number: 29,
    page: 38,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.10",
    skill_area: "Fire Ground Operations: Advance an uncharg ed attack hose line up a ladder",
    task: "Advance an uncharged attack hose line up a ladder.",
    conditions: "The candidate, given a uncharged attack line, team members, a ladder in place, and in full protective equipment, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team, shall advance an uncharged attack hose line up a ladder.",
    task_steps: [
      {
        number: 1,
        task_step: "Ensure lead firefighter drapes nozzle or coupling over shoulder and advances up ladder"
      },
      {
        number: 4,
        task_step: "Direct a firefighter to heel the ladder"
      },
      {
        number: 5,
        task_step: "Ensure no more than one firefighter per section of ladder"
      },
    ]
  },
  {
    skill_sheet_number: 30,
    page: 39,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.10",
    skill_area: "Fire Ground Operations: Operating a charged attack hose line from a ground ladder",
    task: "Demonstrate operating a charged attack hose line from a ground ladder.",
    conditions: "The candidate, given a charged attack line, team members, a ladder in place and heeled or secured, hose strap, and in full protective equipment, shall demonstrate the ability to:",
    performance_outcome: "The candidate shall operate a charged attack line from a ladder.",
    task_steps: [
      {
        number: 1,
        task_step: "Position firefighter(s) on ladder with no more than one firefighter per ladder section"
      },
      {
        number: 2,
        task_step: "Firefighter operating nozzle secures to ladder with leg lock or safety harness"
      },
      {
        number: 3,
        task_step: "Place nozzle through rung of ladder, extending the hose at least one foot in front of firefighter’s body"
      },
      {
        number: 4,
        task_step: "Tie off hose with a clove hitch"
      },
      {
        number: 5,
        task_step: "Ensure slack is secured in the hose"
      },
      {
        number: 6,
        task_step: "Ensure nozzle is opened when secured"
      },
      {
        number: 7,
        task_step: "Ensure fire stream is directed at the designated target"
      },
      {
        number: 8,
        task_step: "Ensure nozzle is opened and closed slowly to prevent water hammer"
      },
    ]
  },
  {
    skill_sheet_number: 31,
    page: 40,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.11",
    skill_area: "Fire Ground Operations: Perform Posit ive Pressure Forced Ventilation",
    task: "While operating as part of a team, perform horizontal ventilation on a structure. (Positive Pressure Forced Ventilation)",
    conditions: "Given necessary tools and equipment, ladders, team members, and in full protective equipment, the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to perform forced mechanical horizontal ventilation by creating intake and exhaust openings as needed and utilizing positive pressure forced ventilation.",
    task_steps: [
      {
        number: 1,
        task_step: "Select point of entry and place Positive Pressure fan several feet outside point of entry"
      },
      {
        number: 2,
        task_step: "Ensure exit point no larger than entry point or in accordance with fan manufacturer's direction"
      },
      {
        number: 3,
        task_step: "Start positive pressure fan and turn fan sideways to opening"
      },
      {
        number: 4,
        task_step: "Select ventilation opening that is not larger than the entry opening a. Place ladder, if necessary b. Select the appropriate tool(s) for task c. Safely carry the selected tool(s) to the window d. Position self to upwind side of window e. Use hand and eye protection f. If breaking glass, keep hands and the tool handle above the point of impact (if applicable) g. Remove remaining glass from frame and any remaining window obstruction(s)"
      },
      {
        number: 5,
        task_step: "Turn positive fan so it is blowing at the point of entrance"
      },
      {
        number: 6,
        task_step: "Open entry point (block open, if necessary) and ensure that the cone of air covers entire opening"
      },
    ]
  },
  {
    skill_sheet_number: 32,
    page: 42,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.11",
    skill_area: "Fire Ground Operations: Perfor m Negative Pressure Ventilation",
    task: "While operating as part of a team, perform horizontal ventilation on a structure.",
    conditions: "Given a scripted scenario, a location adequate to meet provisions of the scenario, necessary tools and equipment, ladders, team members, and in full protective equipment, the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team during a structure fire, shall be able to perform horizontal ventilation by creating intake and exhaust openings as needed and utilizing negative pressure forced ventilation.",
    task_steps: [
      {
        number: 1,
        task_step: "Select exhaust opening a. Place ladder, if necessary b. Select the appropriate tool(s) for task c. Safely carry the selected tool(s) to the window d. Position self to upwind side of window e. Use hand and eye protection f. If breaking glass, keep hands and the tool handle above the point of impact (if applicable) g. Remove remaining glass from frame and any remaining window obstruction(s)"
      },
      {
        number: 2,
        task_step: "Place fan in exhaust opening by hanging from window or door casing, door edge (with door blocked open), or from leaning ladder over opening"
      },
      {
        number: 3,
        task_step: "Prevent churning by covering the area around fan with salvage covers or other material"
      },
      {
        number: 4,
        task_step: "Create an entrance opening, preferably on upwind side of building"
      },
    ]
  },
  {
    skill_sheet_number: 33,
    page: 43,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.11",
    skill_area: "Fire Ground Operations: Perform Hydraulic Ventilation",
    task: "While operating as part of a team, perform horizontal ventilation on a structure.",
    conditions: "Given necessary tools and charged 1 ½” or 1 ¾” hose line, team members, and in full protective equipment on air, the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a mem ber of a team, shall be able to perform forced ventilation by creating exhaust openings as needed and utilizing hydraulic forced ventilation.",
    task_steps: [
      {
        number: 1,
        task_step: "Select an exhaust opening"
      },
      {
        number: 2,
        task_step: "Create ventilation opening by opening or breaking a window. Remove any obstructions such as blinds, curtains, or screens. a. Select the appropriate tool(s) for task b. Safely carry the selected tool(s) to the window c. Position self to side of window d. Use hand and eye protection e. If breaking glass, keep hands and the tool handle above the point of impact (if applicable) f. Remove remaining glass from frame and any remaining window obstruction(s)"
      },
    ]
  },
  {
    skill_sheet_number: 34,
    page: 44,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.12",
    skill_area: "Fire Ground Operations: Perform Vertical Ventilation Flat Roof",
    task: "While operating as part of a team, perform vertical ventilation on a flat roof.",
    conditions: "Given a scripted scenario with roof access established, flat roof, pick -head axe, pike pole, power saw chain and/or circular saw, a team, and in full protective clothing with SCBA (on air when on roof) the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at a simulated structure fire, shall be able to properly perform vertical ventilation on a structure with a flat roof.",
    task_steps: [
      {
        number: 1,
        task_step: "Collect and organize necessary equipment and tools"
      },
      {
        number: 2,
        task_step: "Ensure power saw operates operation ( may be taken to roof while running with chain brake on)"
      },
      {
        number: 3,
        task_step: "Direct team member to heel the ladder or tie off the ladder to the structure"
      },
      {
        number: 4,
        task_step: "Ascend the ladder carrying selected forcible entry tool or hoist ventilation tool(s) to the roof"
      },
      {
        number: 5,
        task_step: "Move tools to roof utilizing teamwork"
      },
      {
        number: 6,
        task_step: "Check roof integrity by sounding roof prior to stepping off ladder"
      },
      {
        number: 7,
        task_step: "Keep sounding roof while moving on the roof"
      },
      {
        number: 8,
        task_step: "Work with wind to back, if possible"
      },
      {
        number: 9,
        task_step: "Locate roof supports, at highest point over fire, by sounding"
      },
      {
        number: 10,
        task_step: "Mark the hole to be cut (as specified) on the roof"
      },
      {
        number: 11,
        task_step: "Clear an opening with hand tools as specified"
      },
      {
        number: 12,
        task_step: "Remove appropriate roof material after cuts"
      },
      {
        number: 13,
        task_step: "Push ceiling through"
      },
      {
        number: 14,
        task_step: "Have team exit roof immediately after completing ventilation, making sure the ladder is heeled"
      },
    ]
  },
  {
    skill_sheet_number: 35,
    page: 46,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.12",
    skill_area: "Fire Ground Operations: Perform vertical ventilation on a pitched r oof",
    task: "While operating as part of a team, perform vertical ventilation on a pitched roof.",
    conditions: "Given a scripted scenario with roof access established and roof ladder in place for a pitched roof, pick - head axe, pike pole, power saw chain and/or circular saw, a team, and in full protective clothing with SCBA (on air when on roof), the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at a simulated structure fire, shall be able to properly perform vertical ventilation on a structure.",
    task_steps: [
      {
        number: 1,
        task_step: "Collect and organize necessary equipment and tools"
      },
      {
        number: 2,
        task_step: "Ensure power saw operation ( may be taken to roof while running with chain brake on)"
      },
      {
        number: 3,
        task_step: "Direct team member to heel the ladder or tie off the ladder to the structure"
      },
      {
        number: 4,
        task_step: "Ascend the ladder carrying selected forcible entry tool or hoist ventilation tool(s) to the roof"
      },
      {
        number: 5,
        task_step: "Move tools to roof utilizing teamwork"
      },
      {
        number: 6,
        task_step: "Check roof integrity by sounding prior to stepping off ladder and"
      },
      {
        number: 7,
        task_step: "Keep sounding roof while moving on the roof"
      },
      {
        number: 8,
        task_step: "Work off roof ladder, when possible, to ensure distribution of weight"
      },
      {
        number: 9,
        task_step: "Work with wind to back, if possible"
      },
      {
        number: 10,
        task_step: "Locate roof supports, at highest point over fire, by sounding"
      },
      {
        number: 11,
        task_step: "Mark the hole to be cut (as specified) on the roof"
      },
      {
        number: 12,
        task_step: "Clear an opening with hand tools as specified"
      },
      {
        number: 13,
        task_step: "Remove or verbalize removing the roofing material"
      },
      {
        number: 14,
        task_step: "Start saw, cut decking diagonally alongside of the rafters, and then complete the cutting of the opening, avoiding cutting through the rafters"
      },
      {
        number: 15,
        task_step: "Remove appropriate roof material after cuts"
      },
      {
        number: 16,
        task_step: "Push ceiling through"
      },
      {
        number: 17,
        task_step: "Have team exit roof immediately after completing ventilation, making sure the ladder is heeled."
      },
    ]
  },
  {
    skill_sheet_number: 36,
    page: 48,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.12",
    skill_area: "Fire Ground Operations: Deploy a Roof ladder",
    task: "Deploy roof ladder on a pitched roof while secured to a ground ladder.",
    conditions: "Given a scripted scenario with roof access established, a roof ladder, and in full protective clothing with SCBA (on air when on roof), the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at a simulated structure fire, shall be able to demonstrate the proper deployment of a roof ladder.",
    task_steps: [
      {
        number: 1,
        task_step: "Carry the roof ladder to the ladder that is to be ascended"
      },
      {
        number: 2,
        task_step: "Lay roof ladder down and open the hooks"
      },
      {
        number: 3,
        task_step: "Check for proper climbing angle of the ladder to be ascended"
      },
      {
        number: 4,
        task_step: "Ensure ladder to be ascended is heeled, secure and locks are fully engaged or tied off"
      },
      {
        number: 5,
        task_step: "Raise roof ladder and rest it against the ladder to be climbed, hooks face out"
      },
      {
        number: 6,
        task_step: "Climb the ladder until the shoulder is about two rungs above the midpoint of the roof ladder"
      },
      {
        number: 7,
        task_step: "Reach through the rungs of the roof ladder and hoist in onto the shoulder"
      },
      {
        number: 8,
        task_step: "Ascend to near the top of the main ladder and lock in using a leg lock or use a ladder belt"
      },
      {
        number: 9,
        task_step: "Once secured, take the roof ladder off shoulder and lay it on the roof with the hooks down or pointed away"
      },
      {
        number: 10,
        task_step: "Push the roof ladder hand over hand toward the peak of the roof until the hooks clear the ridge"
      },
      {
        number: 11,
        task_step: "Ensure that the hooks catch securely over the peak of the rook"
      },
    ]
  },
  {
    skill_sheet_number: 37,
    page: 49,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.12",
    skill_area: "Fire Ground Operations: Carry tool(s) up and down a ladder",
    task: "Carry tool(s) up and down a ladder.",
    conditions: "Given a scripted scenario with roof access established, a roof ladder in place, ventilation -related or forcible entry tool(s), and in full protective clothing with SCBA (on air when on roof), the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at a simulated structure fire, shall be able to demonstrate the proper method of carrying a tool(s) while ascending and descending a ladder.",
    task_steps: [
      {
        number: 1,
        task_step: "Check ladder for proper climbing angle before ascending"
      },
      {
        number: 2,
        task_step: "Ensure ladder to be ascended is heeled, secure and locks are fully engaged or tied off, and positioned for task assigned,"
      },
      {
        number: 4,
        task_step: "Keep arms straight, body away from the ladder and perpendicular to the ground"
      },
      {
        number: 5,
        task_step: "Use legs (do not pull up with the arms)"
      },
      {
        number: 6,
        task_step: "Occasionally glance at the tip of the ladder"
      },
      {
        number: 7,
        task_step: "Climb to the instructed height"
      },
      {
        number: 8,
        task_step: "During decent, slide the free hand under the beam while holding the tool in the other hand and slide the tool along the other beam"
      },
    ]
  },
  {
    skill_sheet_number: 38,
    page: 50,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.13",
    skill_area: "Fire Ground Operations: Overhaul a fire scene",
    task: "Overhaul a fire scene.",
    conditions: "Given a scenario, attack line, water fire extinguisher, hand tools, electronic sensor may be furnished, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating at the scene of a simulated or live structure fire, shall properly perform overhaul so that hidden fires are discovered and extinguished with any evidence present preserved.",
    task_steps: [
      {
        number: 1,
        task_step: "Properly wear full protective clothing and SCBA on air and ensure that team members are in full protective clothing and SCBA on air"
      },
      {
        number: 2,
        task_step: "Select proper equipment and extinguishing source for the overhaul according to scenario"
      },
      {
        number: 3,
        task_step: "Demonstrate locating hidden fires by sight, touch, sound, or electronic sensor"
      },
      {
        number: 4,
        task_step: "Expose hidden fires in ceiling, walls, and/or floors"
      },
      {
        number: 5,
        task_step: "Remove or extinguish burning objects"
      },
      {
        number: 6,
        task_step: "Evaluate for complete extinguishment"
      },
      {
        number: 7,
        task_step: "Preserve evidence or signs of origin and cause"
      },
    ]
  },
  {
    skill_sheet_number: 39,
    page: 51,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.13",
    skill_area: "Fire Ground Operations: Deploy an attack hose line shoulder method",
    task: "Deploy and operate an attack line.",
    conditions: "Given a scenario, attack line, and in full protective equipment (on air if attacking the fire), the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating at the scene of a simulated or live structure fire, shall properly deploy and operate an attack hose line of 1 ½” or 1 ¾” size.",
    task_steps: [
      {
        number: 1,
        task_step: "Properly wear full protective clothing and SCBA on air and ensure that team members are in full protective clothing and SCBA on air"
      },
      {
        number: 2,
        task_step: "Select pre connect hose bed"
      },
      {
        number: 3,
        task_step: "Pull hose load partially out of the bed"
      },
      {
        number: 4,
        task_step: "Place load on shoulder while turning face away from load"
      },
      {
        number: 5,
        task_step: "Walk away from apparatus pulling remainder of hose out of the bed by the bottom loop"
      },
      {
        number: 6,
        task_step: "Pay off hose from top of shoulder load to designated target area"
      },
      {
        number: 7,
        task_step: "Remove or have removed kinks in hose"
      },
      {
        number: 8,
        task_step: "Secure nozzle, call or signal for water, bleed air from the attack line, and adjust nozzle for desired stream before entering area of fire attack"
      },
      {
        number: 9,
        task_step: "Close nozzle slowly enough to prevent water hammer"
      },
    ]
  },
  {
    skill_sheet_number: 40,
    page: 52,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.14",
    skill_area: "Fire Ground Operations: Conserve property as a member of a team",
    task: "Conserve property as a member of a team.",
    conditions: "Given salvage tools and equipment, team members, and in full protective clothing (SCBA at option of evaluator), the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at a simulated live fire scene, shall properly perform salvage operations.",
    task_steps: [
      {
        number: 1,
        task_step: "Arrange furnishing in a close pile(s) and raised off the floor, if possible"
      },
      {
        number: 2,
        task_step: "Cover the pile with a salvage cover using one of the options listed below (circle option used): a. One firefighter throw with one firefighter spread b. Two firefighter balloon throw with two firefighter spread Other: __________________________"
      },
      {
        number: 3,
        task_step: "Construct or perform one of the below called for (circle one used): a. Water Catch- All b. Water Chute c. Stop Activated Sprinkler"
      },
    ]
  },
  {
    skill_sheet_number: 41,
    page: 53,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.14",
    skill_area: "Fire Ground Operations: Conserve property as a member of a team",
    task: "Conserve property as a member of a team.",
    conditions: "Given salvage tools and equipment, team members, and in full protective clothing (SCBA at option of evaluator), the candidate, as team leader, shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating as a member of a team at a simulated live fire scene, shall properly perform salvage operations.",
    task_steps: [
      {
        number: 1,
        task_step: "Demonstrate ability to cover building openings, including doors, windows, floor openings, and roof openings (according to scenario given)"
      },
      {
        number: 2,
        task_step: "Separate, remove, and relocate charred material to a safe location while protecting the area of origin for cause determination"
      },
      {
        number: 3,
        task_step: "Turn off a main control valve on an automatic sprinkler system"
      },
    ]
  },
  {
    skill_sheet_number: 42,
    page: 54,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.15",
    skill_area: "Fire Ground Operations: Connect a fire depar tment pumper to a water supply",
    task: "Connect a fire department pumper to a water supply. (Use Fire Hydrant)",
    conditions: "Given a hydrant, supply hose, hydrant tools, necessary adaptors, hose tools, and in full protective clothing (SCBA at evaluator option), the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating at a simulated structure fire, shall be able to properly connect a supply hose to a hydrant and furnish water to a pumper.",
    task_steps: [
      {
        number: 1,
        task_step: "Connect supply hose to hydrant"
      },
      {
        number: 2,
        task_step: "Insure supply hose connected to pump intake or hose is clamped"
      },
      {
        number: 3,
        task_step: "Flake hose to reduce kinks when charged"
      },
      {
        number: 4,
        task_step: "Fully open hydrant"
      },
      {
        number: 5,
        task_step: "Remove kinks from charged hose"
      },
      {
        number: 6,
        task_step: "At end of operation, fully close the hydrant"
      },
      {
        number: 7,
        task_step: "Place all equipment and hydrant in a ready condition"
      },
    ]
  },
  {
    skill_sheet_number: 43,
    page: 55,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.15",
    skill_area: "Fire Ground Operations: Connect a fire department pumper to a water suppl y. (Note: Static water source)",
    task: "Connect a fire department pumper to a water supply. (Note: Static water source.)",
    conditions: "Given a static water source, hard suction hose, adequate utility rope, hose tools, and in full protective clothing, while operating as team leader, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating at simulated fire scene, shall be able to properly connect a supply hose to a static water source and furnish water to a pumper by drafting.",
    task_steps: [
      {
        number: 1,
        task_step: "Deploy portable water tank"
      },
      {
        number: 2,
        task_step: "Check gaskets on the hard suction hose for dirt, gravel, or defects"
      },
      {
        number: 3,
        task_step: "Connect strainer to hose"
      },
      {
        number: 4,
        task_step: "Fasten rope to strainer to aid in handling the hose"
      },
      {
        number: 5,
        task_step: "Couple two sections of hard suction hose"
      },
      {
        number: 6,
        task_step: "Remove steamer port cap or valve"
      },
      {
        number: 7,
        task_step: "Connect hard suction hose to pumper"
      },
      {
        number: 8,
        task_step: "Use rubber mallet and/or spanner (as appropriate) to ensure air -tight connections"
      },
      {
        number: 9,
        task_step: "Lower hose and strainer into static water source"
      },
      {
        number: 10,
        task_step: "Signal pump operator to start drafting procedure"
      },
    ]
  },
  {
    skill_sheet_number: 44,
    page: 56,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.16",
    skill_area: "Fire Ground Operations: Extinguish incipient Class A fire with appropriate fire extinguisher",
    task: "Extinguish incipient Class A fire with appropriate fire extinguisher.",
    conditions: "Given a selection of fire extinguishers, a small Class A fire, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while at the scene of a small Class A fire, shall be able to select an appropriate fire extinguisher and to properly extinguish the fire .",
    task_steps: [
      {
        number: 1,
        task_step: "Correctly identify the class of fire"
      },
      {
        number: 2,
        task_step: "Select an extinguisher suitable for Class A fires"
      },
      {
        number: 3,
        task_step: "Safely carry and properly activate the extinguisher (pull pin and/or puncture cartridge)"
      },
      {
        number: 4,
        task_step: "Test operation of the extinguisher by a brief discharge of agent"
      },
      {
        number: 6,
        task_step: "Discharge extinguishing agent on the base of the fires and sweep over the fire area"
      },
      {
        number: 7,
        task_step: "Advance on the remaining burning material while continuing to extinguish hot spots"
      },
    ]
  },
  {
    skill_sheet_number: 45,
    page: 57,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.16",
    skill_area: "Fire Ground Operations: Extinguish incipient Class B fire with appropriate fire extin guisher",
    task: "Extinguish incipient Class B fire with appropriate fire extinguisher.",
    conditions: "Given a selection of fire extinguishers, a small Class B fire, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while at the scene of a small Class B fire, shall be able to select an appropriate fire extinguisher and to properly extinguish the fire .",
    task_steps: [
      {
        number: 1,
        task_step: "Correctly identify the class of fire"
      },
      {
        number: 2,
        task_step: "Select an extinguisher suitable for Class B fires"
      },
      {
        number: 3,
        task_step: "Safely carry and properly activate the extinguisher (pull pin and/or puncture cartridge)"
      },
      {
        number: 4,
        task_step: "Test operation of the extinguisher by a brief discharge of agent"
      },
      {
        number: 6,
        task_step: "Discharge extinguishing agent on the base of the fire and sweep over the fire area"
      },
      {
        number: 7,
        task_step: "Advance on the remaining burning material while continuing to extinguish burning fuel"
      },
      {
        number: 8,
        task_step: "Extinguish the fire and watch for reflash of flammable liquids"
      },
    ]
  },
  {
    skill_sheet_number: 46,
    page: 58,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.16",
    skill_area: "Fire Ground Operations: Extinguish incipient Class C fire with appropriate fire extinguisher",
    task: "Extinguish incipient Class C fire with appropriate fire extinguisher.",
    conditions: "Given a selection of fire extinguishers, a small Class C fire, and in full protective equipment, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while at the scene of a small Class C fire, shall be able to select an appropriate fire extinguisher and to properly extinguish the fire .",
    task_steps: [
      {
        number: 1,
        task_step: "Correctly identify the class of fire"
      },
      {
        number: 2,
        task_step: "Attempt to (or verbalize attempt) shut off power supply to the equipment before fighting the fire"
      },
      {
        number: 3,
        task_step: "Select an extinguisher suitable for Class C fires"
      },
      {
        number: 4,
        task_step: "Safely carry and properly activate the extinguisher (pull pin and/or puncture cartridge)"
      },
      {
        number: 5,
        task_step: "Test operation of the extinguisher by a brief discharge of agent"
      },
      {
        number: 7,
        task_step: "Discharge extinguishing agent on the base of the fire and sweep over the fire area"
      },
      {
        number: 8,
        task_step: "Advance on the remaining burning material while continuing to extinguish hot spots"
      },
      {
        number: 9,
        task_step: "Extinguish the fire and check for remaining hot spots"
      },
    ]
  },
  {
    skill_sheet_number: 47,
    page: 59,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.17",
    skill_area: "Fire Ground Operations: Illuminate the emergency scene",
    task: "Operate emergency scene lighting .",
    conditions: "Given fire service lighting equipment (portable or mounted power supply, lights, cords, connectors, and ground fault interrupters), and in full protective clothing (SCBA evaluator option), the candidate shall demonstrate illuminating the fire scene .",
    performance_outcome: "The candidate, while operating on a simulated fire ground, shall be able to properly and safely illuminate the scene and ensure the equipment is operated within manufacturer's safety precautions.",
    task_steps: [
      {
        number: 1,
        task_step: "Lift equipment using proper lifting techniques"
      },
      {
        number: 2,
        task_step: "Locate power plant in a remote and well -vented location"
      },
      {
        number: 3,
        task_step: "Start power plant"
      },
      {
        number: 4,
        task_step: "Arrange power cords neatly to minimize trip hazards"
      },
      {
        number: 5,
        task_step: "Organize lights in a useful position to illuminate the area sufficiently"
      },
      {
        number: 6,
        task_step: "Plug cords into power unit or junction box and furnish illumination"
      },
      {
        number: 7,
        task_step: "Shut down equipment when told to do so (according to manufactures’ recommendation)"
      },
      {
        number: 8,
        task_step: "Reset ground- fault interrupter devices if tripped"
      },
    ]
  },
  {
    skill_sheet_number: 48,
    page: 60,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.18",
    skill_area: "Fire Ground Operations: Turn off building utilities",
    task: "Turn off building utilities.",
    conditions: "Given necessary tools and a structure location adequate to meet the provisions of the objectives or simulations, and in full protective clothing (SCBA evaluator option), the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, while operating on a simulated fire ground, shall be able to locate and properly turn off the utilities to a structure and assess area for related hazards.",
    task_steps: [
      {
        number: 1,
        task_step: "Electrical –main breaker(s) to \"off\" only"
      },
      {
        number: 2,
        task_step: "Natural gas - gas cock to \"off\""
      },
      {
        number: 3,
        task_step: "LPG/CNG - turn valve clockwise to close"
      },
      {
        number: 4,
        task_step: "Water - turn valve clockwise to close or water valve cross way to direction of flow"
      },
      {
        number: 5,
        task_step: "Assess area and verbalize any related hazards"
      },
    ]
  },
  {
    skill_sheet_number: 49,
    page: 61,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.19",
    skill_area: "Fire Ground Operations: Combat a ground cover fire",
    task: "Combat a ground cover fire operating as a member of a team.",
    conditions: "Given a ground cover fire (edge marked by tape, paper, rope, etc.) with flame lengths less than 4 feet and a charged attack line, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate, as a member of a team at a simulated ground cove r fire, shall be able to properly assess incident conditions, use a direct attack method, and utilize LCES (Lookout, communications, escape routes, and safety zones).",
    task_steps: [
      {
        number: 1,
        task_step: "Wear full protective clothing (SCBA and hood not required, wild land protective clothing recommended, if available)"
      },
      {
        number: 2,
        task_step: "Perform an assessment to establish an anchor point"
      },
      {
        number: 3,
        task_step: "identify the exposures presented and what protection is needed"
      },
      {
        number: 4,
        task_step: "Bleed air from hose line and adjust pattern to narrow fog"
      },
      {
        number: 5,
        task_step: "Perform a direct attack from an anchor point to suppress fire"
      },
      {
        number: 6,
        task_step: "Identify the need for lookouts, communications, safety zones, and escape routes"
      },
    ]
  },
  {
    skill_sheet_number: 50,
    page: 62,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.20",
    skill_area: "Fire Ground Operations: Hoist Tool or Equipment",
    task: "Tie a knot appropriate for hoisting tool .",
    conditions: "Given appropriate and adequate rope(s), a tool or equipment, and in full protective clothing, the candidate shall demonstrate the ability to hoist tools using specific knots based on the type of tool:",
    performance_outcome: "The candidate, while operating on a simulated fire ground, shall be able to tie an approved knot, hoist or have hoisted a tool or piece of equipment to a designated height, as specified by scenario.",
    task_steps: [
      {
        number: 1,
        task_step: "Tie a secure, appropriate knot(s) for the tool or equipment selected"
      },
      {
        number: 2,
        task_step: "Incorporate a safety knot when not using a tag line"
      },
      {
        number: 3,
        task_step: "Hoist or have hoisted a tool and/or piece of equipment to a designated height"
      },
      {
        number: 4,
        task_step: "Maintain control of object being hoisted to prevent it from swinging out of control while hoisting (tag line required except when hoisting hose line)"
      },
      {
        number: 5,
        task_step: "Circle tool(s) and/or piece of equipment selected by evaluator: Axe (must be hoisted head down) pike pole (must be hoisted head up) Smoke ejector chain saw hose line (wet or dry) ground ladder"
      },
    ]
  },
  {
    skill_sheet_number: 51,
    page: 63,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.3.21",
    skill_area: "Fire Ground Operations: Air Monitoring",
    task: "Operate an air monitoring instrument.",
    conditions: "Given an assignment or task the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall ensure the air monitoring instrument is operating and recognizes the alarms and takes steps to mitigate the hazard.",
    task_steps: [
      {
        number: 1,
        task_step: "Candidate shall demonstrate the ability to operate an air monitoring instrument according to manufactures’ recommendations and AHJ policies and procedures"
      },
      {
        number: 2,
        task_step: "Ensure all responders are wearing appropriate PPE"
      },
      {
        number: 3,
        task_step: "Perform initial inspection and determine the monitor is serviceable."
      },
      {
        number: 4,
        task_step: "Perform bump test to insure meter is functioning properly"
      },
      {
        number: 5,
        task_step: "Monitor the alarm according to AHJ policy"
      },
      {
        number: 6,
        task_step: "If there is an activation of the alarm, identify the cause and follow AHJ procedures"
      },
      {
        number: 7,
        task_step: "Report results according local protocol"
      },
      {
        number: 8,
        task_step: "When monitoring has been completed, turn off instrument, decontaminate the monitor and return to service per manufacturer’s instructions."
      },
      {
        number: 9,
        task_step: "Complete all required reports and supporting documentation per AHJ"
      },
    ]
  },
  {
    skill_sheet_number: 52,
    page: 64,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.5.1",
    skill_area: "Fire Ground Operations: Clean and checking Ladders",
    task: "Clean and visually check ladders .",
    conditions: "Given a fire department extension ladder, cleaning supplies, marker, and proper lubricant, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to properly clean and visually check a fire department ladder .",
    task_steps: [
      {
        number: 1,
        task_step: "Remove dirt with brush and running water"
      },
      {
        number: 2,
        task_step: "Use approved solvents to remove any oily and greasy residue"
      },
      {
        number: 3,
        task_step: "Wipe dry"
      },
      {
        number: 4,
        task_step: "Examine all beams, guides, halyard, cables, pawls, pulleys, rails, rungs, bolts, rivets, welds, heat indicator(sensors), and movable parts"
      },
      {
        number: 5,
        task_step: "Check lubrication of moveable parts and lubricate, if necessary"
      },
      {
        number: 6,
        task_step: "Mark defects when found in accordance with manufacturer or in accordance with AHJ guidelines"
      },
    ]
  },
  {
    skill_sheet_number: 53,
    page: 65,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.5.1",
    skill_area: "Fire Ground Operations: Clean and checking Ropes",
    task: "Clean and check ropes.",
    conditions: "Given a fire department rope(s) and cleaning supplies, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to properly clean and check fire department rope(s).",
    task_steps: [
      {
        number: 1,
        task_step: "Examine the entire surface of the rope for cuts, abrasions, stains, or fraying"
      },
      {
        number: 2,
        task_step: "Examine the inner component by twisting the rope or feeling for bunching and thinness"
      },
      {
        number: 3,
        task_step: "Verbally explain how to tag and/or remove damaged rope from service when asked by the evaluator"
      },
      {
        number: 4,
        task_step: "Clean rope using clear water only if synthetic rope"
      },
      {
        number: 5,
        task_step: "Allow rope to dry completely, or state rope must be allowed to dry"
      },
      {
        number: 6,
        task_step: "Properly store rope using coil method or rope bag storage"
      },
    ]
  },
  {
    skill_sheet_number: 54,
    page: 66,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.5.1",
    skill_area: "Fire Ground Operations: Clean and check SCBA",
    task: "Cleaning and sanitizing SCBA.",
    conditions: "Given a fire department SCBA and proper cleaning supplies, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall demonstrate cleaning and sanitizing a SCBA.",
    task_steps: [
      {
        number: 1,
        task_step: "Inspect all rubber/elastomer parts for cracks and other damage"
      },
      {
        number: 2,
        task_step: "Wash the assembly in warm water containing an approved cleaner/disinfectant"
      },
      {
        number: 3,
        task_step: "Rinse with clear, warm water"
      },
      {
        number: 4,
        task_step: "Air dry or dry with a lint -free cloth (never uses a paper towel)"
      },
      {
        number: 5,
        task_step: "Ensure the proper operation of the exhalation valve NO. OTHER COMPONENTS"
      },
      {
        number: 1,
        task_step: "Wipe off the entire unit using a soft cloth and an approved cleaner/disinfectant NO. SCBA HARNESS"
      },
      {
        number: 1,
        task_step: "Wash with mild soap or commercial cleaning agent"
      },
      {
        number: 2,
        task_step: "Rinse thoroughly"
      },
      {
        number: 3,
        task_step: "Allow to air dry"
      },
    ]
  },
  {
    skill_sheet_number: 55,
    page: 67,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.5.1",
    skill_area: "Fire Ground Operations: Inspect SCBA",
    task: "Clean and Inspect SCBA .",
    conditions: "Given a fire department SCBA, cleaning tools, and supplies, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to inspect a SCBA to show that it is in a safe condition for immediate use.",
    task_steps: [
      {
        number: 1,
        task_step: "Check straps and backpack assembly"
      },
      {
        number: 2,
        task_step: "Check condition and hydrostatic test date of cylinder"
      },
      {
        number: 3,
        task_step: "Turn the cylinder valve on fully"
      },
      {
        number: 5,
        task_step: "Check face piece, hose, and exhalation valve by inhaling and exhaling"
      },
      {
        number: 6,
        task_step: "Check regulator operation by connecting to face piece and breathing"
      },
      {
        number: 7,
        task_step: "Check by -pass operation and ensure by -pass is in the off position after testing"
      },
      {
        number: 8,
        task_step: "Check low pressure alarm while bleeding the air line"
      },
      {
        number: 10,
        task_step: "Candidate will tab unit out of service and/or notify supervisor of any irregularities found"
      },
      {
        number: 11,
        task_step: "Check straps and backpack assembly"
      },
    ]
  },
  {
    skill_sheet_number: 56,
    page: 68,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.5.1",
    skill_area: "Fire Ground Operations: Clean and checking salvage equipment",
    task: "Clean and check salvage equipment .",
    conditions: "Given selected salvage equipment and/or a salvage cover and cleaning supplies, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to properly clean and check fire department salvage equipment.",
    task_steps: [
      {
        number: 1,
        task_step: "Clean provided salvage equipment"
      },
      {
        number: 2,
        task_step: "Inspect equipment and identify damage NO. SALVAGE COVER IF PROVIDED"
      },
      {
        number: 1,
        task_step: "Spread the salvage cover out flat for cleaning"
      },
      {
        number: 2,
        task_step: "Scrub the cover with detergent solution and a brush"
      },
      {
        number: 3,
        task_step: "Rinse cover thoroughly"
      },
      {
        number: 4,
        task_step: "State cover should be thoroughly dried before returning to service"
      },
      {
        number: 5,
        task_step: "Check the cover thoroughly for damage by having assistants hold the cover above heads while looking for holes or tears"
      },
      {
        number: 6,
        task_step: "Use department procedure for indicating repair needed"
      },
      {
        number: 7,
        task_step: "Fold salvage cover (used as rolled salvage cover and/or a folded salvage cover) for reuse"
      },
    ]
  },
  {
    skill_sheet_number: 57,
    page: 69,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.5.1",
    skill_area: "Fire Ground Operations: Clean and checking hand and power tools",
    task: "Clean and check fire department hand and power tools .",
    conditions: "Given selected fire department hand tools and cleaning, and maintenance supplies, the candidate shall demonstrate the ability to:",
    performance_outcome: "The candidate shall be able to properly clean and check fire department hand tools.",
    task_steps: [
      {
        number: 1,
        task_step: "Check for cracks, blisters, or splinters"
      },
      {
        number: 2,
        task_step: "Sand wooden handles, if needed"
      },
      {
        number: 3,
        task_step: "Clean with soapy water, rinse, and dry after use"
      },
      {
        number: 4,
        task_step: "Apply coat of boiled linseed oil to the handle"
      },
      {
        number: 5,
        task_step: "Check to ensure head is on tight NO. FIBERGLASS HANDLES"
      },
      {
        number: 1,
        task_step: "Wash with warm, soapy water"
      },
      {
        number: 2,
        task_step: "Dry with soft, dry cloth"
      },
      {
        number: 3,
        task_step: "Check to ensure head is on tight NO. CUTTING EDGES"
      },
      {
        number: 1,
        task_step: "Check to ensure cutting edge is free of nicks or tears"
      },
      {
        number: 2,
        task_step: "File the edges by hand using a flat file NO. PLATED SURFACES"
      },
      {
        number: 1,
        task_step: "Inspect for damage"
      },
      {
        number: 2,
        task_step: "Wipe plated surface clean or wash with soap and water NO. UNPROTECTED METAL SURFACES"
      },
      {
        number: 3,
        task_step: "Keep clean of rust"
      },
      {
        number: 4,
        task_step: "Keep oiled when not in use (Light machine oil will work)"
      },
      {
        number: 5,
        task_step: "Check to ensure not painted, as this may hide cracks"
      },
      {
        number: 1,
        task_step: "Check blades for sharpness and equipment for completeness and readiness"
      },
      {
        number: 2,
        task_step: "Check electric cords for cuts and frays"
      },
      {
        number: 3,
        task_step: "Check that appropriate guards are in place"
      },
    ]
  },
  {
    skill_sheet_number: 58,
    page: 71,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.5.2",
    skill_area: "Fire Ground Operations: Clean, Inspect, and Return Fire Hose t o Service",
    task: "Clean and inspect fire hose.",
    conditions: "Given fire hose, cleaning supplies, replacement gaskets, and personal protective clothing, the candidate shall demonstrate the ability to: (The evaluator will determine what personal protective clothing will be worn)",
    performance_outcome: "The candidate shall be abl e to properly clean and inspect fire hose.",
    task_steps: [
      {
        number: 1,
        task_step: "Clean hose using water and scrub brush (mild detergent may be used)"
      },
      {
        number: 2,
        task_step: "Clean couplings by removing gaskets, wash with warm soapy water, and reinstall gaskets (replacing if defective)"
      },
      {
        number: 3,
        task_step: "State that hose should be dried"
      },
      {
        number: 4,
        task_step: "Operate hose washing and drying equipment per manufacture’s specifications according to AHJ ( if applicable) INSPECT HOSE"
      },
      {
        number: 1,
        task_step: "Check for signs of mechanical damage"
      },
      {
        number: 2,
        task_step: "Check for dirt and debris"
      },
      {
        number: 3,
        task_step: "Check for loose couplings"
      },
      {
        number: 4,
        task_step: "Check for damaged male or female threads"
      },
      {
        number: 5,
        task_step: "Check to see that swivel operates freely"
      },
      {
        number: 6,
        task_step: "Mark defective hose and place damaged hose out of service until repaired"
      },
    ]
  },
  {
    skill_sheet_number: 59,
    page: 72,
    nfpa_standard: "1001, 2019 Edition",
    jpr: "4.5.2",
    skill_area: "Fire Ground Operations : Clean, Inspect, and Return Fire Hose to Service",
    task: "Return fire hose to service.",
    conditions: "Given fire hose, team members, and personal protective clothing, the candidate shall demonstrate the ability to: (The evaluator will determine what personal protective clothing will be worn)",
    performance_outcome: "The candidate shall be able to properly return fire hose to ser vice.",
    task_steps: [
      {
        number: 1,
        task_step: "Roll hose by two different rolls selected by candidate (circle rolls) a. STRAIGHT b. DONUT c. TWIN DONUT d. SELF -LOCKING TWIN DONUT"
      },
      {
        number: 2,
        task_step: "Correctly roll (circle one) A B C D roll"
      },
      {
        number: 3,
        task_step: "Correctly roll (circle one) A B C D roll Load hose by a supply line load and a preconnect line load (circle loads that are selected by the candidate) Supply Line – a. ACCORDION b. HORSESHOE c. FLAT Preconnect – d. Flat e. TRIPLE MINUTEMAN F. Department Specific"
      },
      {
        number: 4,
        task_step: "Correctly load (circle one) A B C Supply load"
      },
      {
        number: 5,
        task_step: "Correctly load (circle one) D E F Preconnect load"
      },
    ]
  }
];

export const WSP_FF1_COLLECTION: SkillSheetCollection = {
  name: "Washington State Fire Protection - Firefighter I Certification",
  skill_sheets: WSP_FF1_SKILL_SHEETS
};

export const SKILL_SHEETS_BANK: SkillSheetsBank = {
  collections: new Map([
    ["wsp_ff1", WSP_FF1_COLLECTION]
  ])
};

// Helper function to get a specific skill sheet by number
export function getSkillSheet(number: number): SkillSheet | undefined {
  return WSP_FF1_SKILL_SHEETS.find(sheet => sheet.skill_sheet_number === number);
}

// Helper function to get skill sheets by JPR
export function getSkillSheetsByJPR(jpr: string): SkillSheet[] {
  return WSP_FF1_SKILL_SHEETS.filter(sheet => sheet.jpr === jpr);
}
